import React, { useState, useEffect } from 'react';
import getConfig from 'next/config';
import jsCookie from 'js-cookie';
import useAuthenticated from '../../utils/hooks/useAuthenticated';
import { MAIN_NAV, USER_NAVS, LOGIN_MENU, LOGOUT_NAV } from './navs';

import LoginModal from '../LoginModal';
import Navbar from './Navbar';

const { ENABLE_OTP_LOGIN } = getConfig().publicRuntimeConfig;

const Navigation = () => {
  const authenticated = useAuthenticated();
  const [showLogin, setShowLogin] = useState(false);

  const handleLogin = () => {
    if (ENABLE_OTP_LOGIN == 'true' && !authenticated) {
      setShowLogin(true);
    }
  };

  const handleLogout = () => {
    jsCookie.remove('token');
    window.location.reload();
  };

  useEffect(() => {
    LOGIN_MENU.onClick = handleLogin;
    LOGOUT_NAV.onClick = handleLogout;
    USER_NAVS[0].childItems.push(LOGOUT_NAV);
  }, []);

  return (
    <div>
      <Navbar
        menu={MAIN_NAV}
        authenticatedMenu={USER_NAVS}
        guestMenu={[LOGIN_MENU]}
        mobileloginAction={handleLogin}
        handleLogout={handleLogout}
        isAuthenticated={authenticated}
        logoPath={'/media/static/images/lifepal-logo.svg'}
      />
      {showLogin && <LoginModal closeModalClick={() => setShowLogin(false)} />}
    </div>
  );
};

export default Navigation;
